module.exports = __webpack_public_path__ + "img/compangPic.3d85b482.png";